import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { replaceTokensInUrl } from '@app/utils';
import { TIMEOUT_FORTY_SECONDS } from '@app/constants/commonConstants';
import { getHttpInstance } from '@app/services/defaultHttpService';
import endpoints from '@app/constants/endpoints';

const useContactUs = () => {
  const storeId = useSelector(s => s.common?.storeId) || null;
  const http = getHttpInstance(TIMEOUT_FORTY_SECONDS);

  const createInquiry = useCallback(
    async payload => {
      const finalUrl = replaceTokensInUrl(
        endpoints.CONTACT_US_INQUIRY,
        storeId
      );
      let statusCode;

      try {
        const { status } = await http.post(finalUrl, payload);
        statusCode = status;
      } catch ({ response: { data, status } }) {
        statusCode = status;
        console.error(data);
      }
      return statusCode;
    },
    [http, storeId]
  );

  return { createInquiry };
};

export default useContactUs;
